import { z } from 'zod';
import { paginationSchema } from '../shared/index.js';
/**
 * Stream action request schema
 * Used by clients to start or stop streaming for a media encoder
 */
export const streamActionSchema = z.object({
    mediaEncoderId: z.number().int().positive(),
});
/**
 * Get stream status request schema
 * Used for query parameters to get the status of a stream
 * Note: Uses coerce to handle query string parameters
 */
export const getStreamStatusSchema = z.object({
    mediaEncoderId: z.coerce.number().int().positive(),
});
/**
 * Query schema for `GET /:id/streaming/events` — limit/offset only; ordering is fixed
 * (`occurredAt desc`) since the endpoint is a fixed audit-trail view, not a sortable list.
 */
export const streamEventsQuerySchema = paginationSchema.pick({ limit: true, offset: true });
